import axios from "axios";
import config from "../config";

function pideCatalogo() {
    return axios({
        method: 'POST',
        url: config.url,
        headers: {
            'Content-Type': 'text/xml; charset=utf-8'
        },
        data: `<?xml version="1.0" encoding="UTF-8"?>
                <request command="pideCatalogo">
                <auth url="${config.qrCode}" />
                <pideCatalogo/>
                </request>`
    });
}

export default pideCatalogo;